import { createAsyncThunk } from "@reduxjs/toolkit";
import getToken from "../../utils/getToken";
import axios, { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { mydata } from "../../_flyingPaws/partials/widgets/_new/engage/AdPopupBannerFrom";

// all urls
const API_URL = process.env.REACT_APP_API_URL;
const CREATE = `${API_URL}/popupBanner/create`;
const GET_ALL = `${API_URL}/popupBanner/all`;
const DELETE = `${API_URL}/popupBanner/delete`;
const EDIT = `${API_URL}/popupBanner/edit`;

type TPopupBannerPayload = {
  id?: string;
  title: string;
  description: string;
  url: string;
  active?: boolean;
};

// getall
export const getAllPopupBanner = createAsyncThunk(
  "get-all-popupBanners",
  async (data: { page: number }) => {
    try {
      const token = getToken();
      if (token) {
        const config: AxiosRequestConfig = {
          headers: {
            Authorization: token,
          },
          data: { ...data, limit: 5 },
          url: GET_ALL,
          method: "GET",
        };
        const res = await axios(config);
        if (res && res.data.data) {
          return res.data.data;
        }

        return [];
      }
    } catch (error: any) {
      const { message } = error?.response?.data;
      toast.error(message);
    }
  }
);

// create popupBanner
export const createPopupBanner = createAsyncThunk(
  "create-popupBanner",
  async (data: TPopupBannerPayload) => {
    const loadingToastId = toast.loading("Please wait..");
    try {
      const token = getToken();
      const config: AxiosRequestConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      };

      const res = await axios.create(config).post(CREATE, data);
      toast.dismiss(loadingToastId);
      toast.success("Popup created successfully");
      return res.data.data;
    } catch (error: any) {
      toast.dismiss(loadingToastId);
      const { message } = error?.response?.data;
      toast.error(message);
    }
  }
);

// // activateAd
// export const activateAd = createAsyncThunk(
//   "activate-ad",
//   async (data: IEngageWidget10InitValues) => {
//     const loadingToastId = toast.loading("Please wait..");
//     try {
//       const token = getToken();
//       const config: AxiosRequestConfig = {
//         url: ACTIVATE_AD,
//         method: "post",
//         headers: {
//           Authorization: token,
//         },
//         data: data,
//       };
//       const res = await axios(config);
//       toast.dismiss(loadingToastId);
//       if (res.data.data.active) {
//         toast.success("Ad is activated successfully");
//       } else {
//         toast.success("Ad is deactivated successfully");
//       }

//       return res.data.data;
//     } catch (error: any) {
//       toast.dismiss(loadingToastId);
//       const { message } = error?.response?.data;
//       toast.error(message);
//     }
//   }
// );

// edit ad
export const editPopUpBanner = createAsyncThunk(
  "edit-popupBanner",
  async (data: any) => {
    const loadingToastId = toast.loading("Please wait..");
    try {
      const token = getToken();
      const config: AxiosRequestConfig = {
        url:EDIT,
        method: "patch",
        headers: {
          Authorization: token,
        },
        data: data,
      };
      const res = await axios(config);
      toast.dismiss(loadingToastId);
      toast.success("Edited successfully");
      return res.data.data;
    } catch (error: any) {
      toast.dismiss(loadingToastId);
      const { message } = error?.response?.data;
      toast.error(message);
    }
  }
);

// delete ad
export const deletePopupBanner = createAsyncThunk(
  "delete-ad",
  async (data: any) => {
    const loadingToastId = toast.loading("Please wait..");
    try {
      const token = getToken();
      const config: AxiosRequestConfig = {
        url: DELETE,
        method: "delete",
        headers: {
          Authorization: token,
        },
        data: {
          id: data.data?._id,
        },
      };
      await axios(config);
      toast.dismiss(loadingToastId);
      toast.success("Deleted successfully");
      return data;
    } catch (error: any) {
      toast.dismiss(loadingToastId);
      const { message } = error?.response?.data;
      toast.error(message);
    }
  }
);
